import useSWR from 'swr'
import axios, { type AxiosRequestConfig } from 'axios'
import { storage } from '@/helpers'
import { useAuth } from '@clerk/clerk-react'
import { API_URL } from '@/constants'

interface RequestConfig extends AxiosRequestConfig {
  url: string
}

interface UseRequestConfig {
  initialData?: any
  [key: string]: any
}

export function useRequest(request: RequestConfig, { initialData, ...config }: UseRequestConfig = {}) {
  const { getToken } = useAuth()

  request.url = `${API_URL}${request.url}`

  const authToken = storage.getItem('token')

  return useSWR(
    request && JSON.stringify(request),
    async () => {
      const jwt = await getToken()
      request.headers = {
        Authorization: jwt ? `Bearer ${jwt}` : `Token ${authToken}`,
      }
      return (await axios(request || {})).data
    },
    {
      ...config,
      fallbackData: initialData && {
        status: 200,
        statusText: 'InitialData',
        data: initialData,
        revalidateOnFocus: false,
      }
    }
  )
}

export default useRequest
